import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';

const diensten = [
  { icon: 'ri-search-2-line', title: 'Product sourcing direct bij fabrieken' },
  { icon: 'ri-price-tag-3-line', title: 'Onderhandelen en prijsoptimalisatie' },
  { icon: 'ri-vip-crown-line', title: 'Private label & maatwerk' },
  { icon: 'ri-settings-3-line', title: 'Productiebegeleiding' },
  { icon: 'ri-ship-line', title: 'Levering (vaak DDP – all-in prijs)' },
  { icon: 'ri-store-2-line', title: 'Doorverkoop van producten' },
];

export default function WieZijnWij() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="wie-zijn-wij" ref={ref} className="py-12 md:py-20 bg-[#F7F8FA] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <motion.span initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }} className="inline-flex items-center gap-2 border border-[#3B9EE8]/40 bg-[#3B9EE8]/10 rounded-full px-4 py-2 text-[#3B9EE8] text-sm font-600 mb-6">
              <i className="ri-building-line" />
              Wie zijn wij
            </motion.span>
            <motion.h2 initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.1 }} className="font-heading font-800 text-[#0A1628] text-3xl md:text-4xl lg:text-5xl leading-tight mb-4">
              Van inkoop tot aftercare
              <br />
              <span className="text-[#3B9EE8]">volledig geregeld</span>
            </motion.h2>
            <motion.p initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.2 }} className="text-[#0A1628]/65 text-lg leading-relaxed mb-6">
              DUC – Direct uit China helpt bedrijven en particulieren om producten direct bij fabrikanten in China in te kopen én te leveren.
            </motion.p>
            <motion.p initial={{ opacity: 0, y: 16 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.3 }} className="text-[#0A1628]/65 text-base leading-relaxed mb-8">
              Wij werken als <strong className="text-[#0A1628]">sourcing partner én leverancier</strong>. Soms kopen wij producten direct in en verkopen wij ze door. Soms werken wij op commissiebasis als inkooppartner. Altijd transparant, altijd met jouw belang voorop.
            </motion.p>
            <motion.div initial={{ opacity: 0, y: 12 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.4 }}>
              <Link
                to="/wie-zijn-wij"
                className="inline-flex items-center gap-2 border border-[#3B9EE8] text-[#3B9EE8] hover:bg-[#3B9EE8] hover:text-white px-6 py-3 rounded-lg font-600 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-heart-line" />
                Meer over ons verhaal
                <i className="ri-arrow-right-line" />
              </Link>
            </motion.div>
          </div>

          <motion.div initial={{ opacity: 0, x: 30 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.6, delay: 0.2 }} className="bg-white rounded-2xl p-8 border border-[#0A1628]/6">
            <div className="mb-6">
              <h3 className="font-heading font-700 text-[#0A1628] text-xl mb-2">Wat doen wij voor jou?</h3>
              <p className="text-[#0A1628]/50 text-sm">Wij kunnen vrijwel elk product leveren: van verpakkingen en accessoires tot machines en maatwerk.</p>
            </div>
            <div className="space-y-4">
              {diensten.map((dienst, i) => (
                <motion.div key={dienst.title} initial={{ opacity: 0, x: 20 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.4, delay: 0.3 + i * 0.08 }} className="flex items-center gap-4 p-4 rounded-xl bg-[#F7F8FA] hover:bg-[#3B9EE8]/8 transition-colors duration-200 cursor-pointer group">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white border border-[#0A1628]/8 group-hover:border-[#3B9EE8]/40 transition-colors flex-shrink-0">
                    <i className={`${dienst.icon} text-[#3B9EE8] text-lg`} />
                  </div>
                  <span className="text-[#0A1628]/80 text-sm font-500 group-hover:text-[#0A1628] transition-colors">{dienst.title}</span>
                  <i className="ri-arrow-right-line text-[#3B9EE8]/40 group-hover:text-[#3B9EE8] ml-auto transition-colors text-sm" />
                </motion.div>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-[#0A1628]/6">
              <button onClick={() => { const el = document.querySelector('#contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="w-full bg-[#3B9EE8] hover:bg-[#2D85C5] text-white font-700 text-sm py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap">
                Vraag gratis prijscheck aan
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
